import { stubFalse } from 'lodash';
import { deleteCreative } from '../../../../../flows';
import {
    CreativeActionsCellRenderer,
    EllipsisCellRenderer,
    FormattedMessageHeaderRenderer,
    FormattedMessageWithTooltipHeaderRenderer,
    formattedNumberValueGetter,
    gridNumberFormatter,
    StateCellRenderer,
    withCreativeEditIndication,
} from '../../../components';
import { editCreative, saveCreative } from '../../../flows';
import { normalizeColumnDefs } from '../../../utils';
import {
    actionsColumnType,
    editableColumn,
    leftPinnedColumn,
    lockedColumn,
    numericColumn,
    rightPinnedColumn,
    staticColumn,
    toggleColumn,
} from '../../columns';
import * as FIELDS from '../../fields';
import { isVideoCreativeEditable } from '../../predicates';
import { CREATIVE_VIDEO_REPORT_ID } from './creativeVideoReportId';

const creativeReportColumnDefinition = [
    {
        headerName: FIELDS.IS_ACTIVE.label,
        field: FIELDS.IS_ACTIVE.field,
        type: [toggleColumn, leftPinnedColumn, staticColumn, lockedColumn],
        cellRendererParams: {
            ...FIELDS.IS_ACTIVE.renderParams,
            isDisabled: stubFalse,
            reportId: CREATIVE_VIDEO_REPORT_ID,
        },
        valueChangeHandler: saveCreative,
        cellRenderer: StateCellRenderer,
        csv: false,
        permissions: {
            permissions: ['ADS_CONSOLE_CREATE_VIDEO_CAMPAIGN'],
        },
    },
    {
        headerName: FIELDS.CREATIVE_NAME.label,
        field: FIELDS.CREATIVE_NAME.field,
        type: [leftPinnedColumn, editableColumn],
        editable: isVideoCreativeEditable,
        cellRenderer: EllipsisCellRenderer,
        cellRendererParams: { lines: 2 },
        cellEditor: FIELDS.CREATIVE_NAME.cellEditor,
        valueChangeHandler: saveCreative,
    },
    {
        headerName: FIELDS.CAMPAIGN_NAME.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.STATUS.headerComponentParams,
        field: FIELDS.CAMPAIGN_NAME.field,
        cellRenderer: FIELDS.CAMPAIGN_NAME.cellRenderer,
    },
    {
        headerName: FIELDS.VIDEO_DURATION.label,
        headerValueGetter: FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: FIELDS.VIDEO_DURATION.headerComponentParams,
        field: FIELDS.VIDEO_DURATION.field,
    },
    {
        headerName: FIELDS.ACTIONS_COLUMN.label,
        field: FIELDS.ACTIONS_COLUMN.field,
        type: [rightPinnedColumn, actionsColumnType, staticColumn],
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        cellRendererParams: {
            onEdit: editCreative,
            onDelete: deleteCreative,
        },
        cellRenderer: CreativeActionsCellRenderer,
        csv: false,
        permissions: {
            permissions: ['ADS_CONSOLE_CREATE_VIDEO_CAMPAIGN'],
        },
    },
    ...[
        FIELDS.SPENT,
        FIELDS.COMPLETED_VIEWS,
        FIELDS.VIDEO_IMPRESSIONS,
        FIELDS.VIDEO_VISIBLE_IMPRESSIONS,
        FIELDS.FIRST_QUARTILE,
        FIELDS.MID_POINT,
        FIELDS.THIRD_QUARTILE,
        FIELDS.COMPLETED_VIDEO,
        FIELDS.THIRTY_SECONDS_MARK,
        FIELDS.VIDEO_CPM,
        FIELDS.VIDEO_VCPM,
        FIELDS.CPCV,
        FIELDS.VIEWABILITY_RATE,
        FIELDS.HUNDRED_PCT_VIEWABILITY_RATE,
        FIELDS.COMPLETION_RATE,
        FIELDS.CLICKS,
        FIELDS.VIDEO_CTR,
        FIELDS.VIDEO_VCTR,
        FIELDS.CPA,
        FIELDS.VIDEO_CVR,
        FIELDS.CONVERSIONS,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        valueFormatter: gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        referenceColId: fieldConfig.referenceColId,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(
    creativeReportColumnDefinition,
    CREATIVE_VIDEO_REPORT_ID,
    withCreativeEditIndication
);
